import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, User, UserCheck, ClipboardList, Target, Dumbbell } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const dagenOpties = ["2", "3", "4", "5", "6"];
const DEFAULT_PRIJZEN = { "2": 9.95, "3": 14.95, "4": 19.95, "5": 24.95, "6": 29.95 };
const fmtPrijs = (p) => `€${Number(p ?? 0).toFixed(2).replace(".", ",")}`;

export default function PersonalTrainingCard() {
  const navigate = useNavigate();
  const [gekozenDagen, setGekozenDagen] = useState("3");
  const [prijzen, setPrijzen] = useState(DEFAULT_PRIJZEN);
  const gekozenPrijs = prijzen[gekozenDagen] ?? DEFAULT_PRIJZEN[gekozenDagen];

  useEffect(() => {
    fetch(`${API}/api/pt/prijzen`)
      .then(r => r.json())
      .then(d => d.prijzen && setPrijzen(d.prijzen))
      .catch(() => {});
  }, []);

  const voordelen = [
    { icon: <UserCheck size={14} />, text: "Volledig gepersonaliseerd schema" },
    { icon: <ClipboardList size={14} />, text: "Op basis van jouw intakeformulier" },
    { icon: <Target size={14} />, text: "Afgestemd op doel, niveau & beschikbaarheid" },
    { icon: <Dumbbell size={14} />, text: "Zelfstandig trainen met professioneel schema" },
  ];

  return (
    <div id="persoonlijk-schema" data-testid="personal-training-card"
      className="product-card flex flex-col h-full relative overflow-hidden"
      style={{ borderColor: "rgba(201,168,76,0.35)", background: "linear-gradient(160deg, #0e0c08 0%, #0a0a0a 60%, #0c100a 100%)" }}>
      <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-[#C9A84C]/6 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-8 -left-8 w-32 h-32 rounded-full bg-[#C9A84C]/4 blur-2xl pointer-events-none" />
      <div className="bundel-badge" style={{ background: "rgba(201,168,76,0.12)", color: "#C9A84C", border: "1px solid rgba(201,168,76,0.25)" }}>
        <UserCheck size={11} /> Op maat gemaakt
      </div>
      <div className="product-card-header" style={{ borderBottom: "1px solid rgba(201,168,76,0.12)" }}>
        <div className="product-card-icon gold-icon"><User size={22} className="text-black" /></div>
        <div>
          <h3 className="text-xl font-bold text-white leading-tight">Persoonlijk<br /><span className="text-[#C9A84C]">Trainingsschema</span></h3>
        </div>
      </div>
      <div className="flex-1 flex flex-col p-6 gap-5 relative">
        <p className="text-zinc-400 text-sm leading-relaxed">
          Een schema volledig afgestemd op jouw lichaam, doelen en planning — samengesteld door een professional na het invullen van je intakeformulier.
        </p>

        {/* Frequentie kiezer */}
        <div>
          <p className="text-zinc-500 text-xs font-bold uppercase tracking-widest mb-2.5">Kies trainingsdagen per week</p>
          <div className="grid grid-cols-2 gap-2">
            {dagenOpties.map(d => (
              <button key={d}
                data-testid={`freq-btn-${d}`}
                onClick={() => setGekozenDagen(d)}
                className="flex items-center justify-between px-3 py-2.5 rounded-xl border text-sm font-semibold transition-all"
                style={gekozenDagen === d ? {
                  background: "rgba(201,168,76,0.15)",
                  borderColor: "rgba(201,168,76,0.6)",
                  color: "#C9A84C",
                } : {
                  background: "rgba(255,255,255,0.03)",
                  borderColor: "rgba(255,255,255,0.08)",
                  color: "#a1a1aa",
                }}>
                <span>{d} dagen</span>
                <span className="font-bold">{fmtPrijs(prijzen[d] ?? DEFAULT_PRIJZEN[d])}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="space-y-3">
          {voordelen.map(({ icon, text }) => (
            <div key={text} className="flex items-center gap-3 text-sm text-zinc-200">
              <div className="w-6 h-6 rounded-md bg-[#C9A84C]/12 flex items-center justify-center text-[#C9A84C] shrink-0">{icon}</div>
              {text}
            </div>
          ))}
        </div>

        <div className="mt-auto pt-4 border-t border-[#C9A84C]/12">
          <div className="flex items-baseline gap-2 mb-4">
            <span data-testid="personal-training-price" className="text-3xl font-bold text-white">{fmtPrijs(gekozenPrijs)}</span>
            <span className="text-zinc-400 text-sm mb-1">· {gekozenDagen} dagen per week</span>
          </div>
          <p className="text-xs text-zinc-600 mb-3 flex items-center gap-1">
            <span className="w-1 h-1 rounded-full bg-zinc-600 inline-block" />
            Dit is een digitaal product. Na aankoop is restitutie niet mogelijk.
          </p>
          <button data-testid="personal-training-cta-btn"
            onClick={() => navigate(`/bestellen?product=persoonlijk_schema&freq=${gekozenDagen}x`)}
            className="btn-gold w-full py-3 font-bold text-sm uppercase tracking-wide flex items-center justify-center gap-2 group">
            Schema aanvragen <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
          </button>
          <p className="text-center text-zinc-600 text-xs mt-3">Geen verborgen kosten</p>
        </div>
      </div>
    </div>
  );
}
